import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "pricelists"

function* loadPricelists(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(url, params, token);
    yield put(actions.loadPricelists.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadPricelists.failure(getErrorMsg(error)));
  }
}

function* showPricelist(action) {
  try {
    const { id, token } = action.payload;
    const res = yield fetcher.get(`${url}/${id}`, token);
    yield put(actions.showPricelist.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.showPricelist.failure(getErrorMsg(error)));
  }
}

function* createPricelist(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/create`, params, token);
    yield put(actions.createPricelist.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.createPricelist.failure(getErrorMsg(error)));
  }
}

function* updatePricelist(action) {
  try {
    const { params, id, token } = action.payload;
    const res = yield fetcher.post(`${url}/update/${id}`, params, token);
    yield put(actions.updatePricelist.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.updatePricelist.failure(getErrorMsg(error)));
  }
}

function* deletePricelist(action) {
  try {
    const { id, token } = action.payload;
    yield fetcher.get(`${url}/delete/${id}`, token);
    yield put(actions.deletePricelist.success(id));
  } catch (error) {
    handleError(error);
    yield put(actions.deletePricelist.failure(getErrorMsg(error)));
  }
}

function* importPricelist(action) {
  try {
    const { file, company_id, user_id, token } = action.payload;
    const formData = new FormData();
    formData.append("file_name", file.originFileObj);
    formData.append("company_id", company_id)
    formData.append("user_id", user_id)
    const res = yield fetcher.upload(`${url}/import`, formData, token);
    yield put(actions.importPricelist.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.importPricelist.failure(getErrorMsg(error)));
  }
}

function* exportPricelist(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/export`, params, token);
    yield put(actions.exportPricelist.success(res.data));
    fetcher.download(res.data.data);
  } catch (error) {
    handleError(error);
    yield put(actions.exportPricelist.failure(getErrorMsg(error)));
  }
}

function* loadPricelistProducts(action) {
  try {
    const { params, token } = action.payload;
    const payload = {
      pricelist_id: params.pricelist_id,
      effective_id: params.effective_id
    };
    const res = yield fetcher.post(`${url}/products`, payload, token);
    yield put(actions.loadPricelistProducts.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadPricelistProducts.failure(getErrorMsg(error)));
  }
}

export default function* watchPricelist() {
  yield all([
    takeEvery(actions.LOAD_PRICELIST.REQUEST, loadPricelists),
    takeEvery(actions.SHOW_PRICELIST.REQUEST, showPricelist),
    takeEvery(actions.CREATE_PRICELIST.REQUEST, createPricelist),
    takeEvery(actions.UPDATE_PRICELIST.REQUEST, updatePricelist),
    takeEvery(actions.DELETE_PRICELIST.REQUEST, deletePricelist),
    takeEvery(actions.IMPORT_PRICELIST.REQUEST, importPricelist),
    takeEvery(actions.EXPORT_PRICELIST.REQUEST, exportPricelist),
    takeEvery(actions.LOAD_PRICELIST_PRODUCTS.REQUEST, loadPricelistProducts),
  ]);
}
